import { render, staticRenderFns } from "./ModernShell.vue?vue&type=template&id=07618808&scoped=true&"
import script from "./ModernShell.vue?vue&type=script&lang=js&"
export * from "./ModernShell.vue?vue&type=script&lang=js&"
import style0 from "./ModernShell.vue?vue&type=style&index=0&id=07618808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07618808",
  null
  
)

export default component.exports